import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HlsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hls"}/>
}
